import React from "react";
import styles from './Footer.module.css';
import fb from '../../assets/home/tokopedia.png';
import linkdin from '../../assets/home/shopee.png';
import insta from '../../assets/home/insta.png';

const Footer = () => {
    return (
        <>
            <div style={{backgroundColor:'#2b2b2b', paddingTop:'89px', paddingBottom:'90px'}}>
                <div className="container">
                    <div className={styles.footerRow}>
                        <div className={styles.footerColumn}>
                            <img
                                src={require('../../assets/home/balemartlogo.png')}
                                alt="Balemart Logo"
                                style={{ height: "40px", display: "block", marginLeft: 0, marginBottom: "20px"}}
                                className={styles.logo}
                            />
                            <p className={styles.text}>Segera kunjungi minimarket kami!</p>
                            <p className={styles.text}>Dapatkan kebutuhan bangunan anda dengan kualitas terbaik!</p>
                            <div className={styles.social_logo}>
                                <a href="https://www.tokopedia.com/balemartbale" target="_blank" rel="noopener noreferrer">
                                    <img src={fb} alt="Tokopedia" className={styles.img} />
                                </a>
                                <a href="https://www.instagram.com/bale_mart?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                                    <img src={insta} alt="Instagram" className={styles.img} />
                                </a>
                            </div>
                        </div>

                        <div className={styles.footerColumn}>
                            <p className={styles.head}>Cabang</p>
                            
                            <div className={styles.branchLocation}>
                                <p className={styles.branchName}>Baleendah</p>
                                <p className={styles.text}>Jl. Raya Laswi No.210, Manggahang, Kec. Baleendah, Kabupaten Bandung, Jawa Barat 40375</p>
                                <p className={styles.contactInfo}>
                                    <span className={styles.contactMethod}>Email: </span>
                                    <a href="mailto:ptwaruwaskita@gmail.com" className={styles.contactLink}>ptwaruwaskita@gmail.com</a>
                                </p>
                                <p className={styles.contactInfo}>
                                    <span className={styles.contactMethod}>Phone: </span>
                                    <a href="tel:+6281220209068" className={styles.contactLink}>(62) 812-2020-9068</a>
                                </p>
                            </div>
                            
                            <div className={styles.branchLocation}>
                                <p className={styles.branchName}>Arjasari</p>
                                <p className={styles.text}>Banjaran Pinggir Sari RT 04 RW 01, Arjasari, Kec. Arjasari, Kabupaten Bandung, Jawa Barat 40379</p>
                                <p className={styles.contactInfo}>
                                    <span className={styles.contactMethod}>Email: </span>
                                    <a href="mailto:waskitaaryaintipratama@gmail.com" className={styles.contactLink}>waskitaaryaintipratama@gmail.com</a>
                                </p>
                                <p className={styles.contactInfo}>
                                    <span className={styles.contactMethod}>Phone: </span>
                                    <a href="tel:+6282324332024" className={styles.contactLink}>(62) 823-2433-2024</a>
                                </p>
                            </div>

                            <div className={styles.branchLocation}>
                                <p className={styles.branchName}>Lembang</p>
                                <p className={styles.text}>Jl. Jayagiri No.42, RT.001, Jayagiri, Kec. Lembang, Kabupaten Bandung Barat, Jawa Barat 40391</p>
                                <p className={styles.contactInfo}>
                                    <span className={styles.contactMethod}>Phone: </span>
                                    <a href="tel:+6281119192020" className={styles.contactLink}>(62) 811-1919-2020</a>
                                </p>
                            </div>
                        </div>

                        <div className={styles.footerColumn}>
                            <p className={styles.head}>Jam Operasional</p>
                            <p className={styles.text}>Mon - Sun : 7:30 - 16:00</p>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{backgroundColor: '#2b2b2b', borderTop: 'solid 1px #707070'}}>
                <p className={styles.bottom}>Copyright © 2025. All right reserved</p>
            </div>
        </>
    )
}

export default Footer;